<template>
  <div>
    <div class="is-flex is-align-center">
      <eden-page-header :title="'Reviews'" />
      <el-dropdown class="dropdown-with-buttons ml-2" @command="setPeriod" :style="{ marginBottom: '50px' }">
        <el-button size="mini" type="primary" plain>
          {{ periods[period] }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(value, key, i) in periods" :key="i" :command="key"
            :class="{ selected: period === key }">{{ value }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog
      v-if="period === 'custom'"
      title="Reviews For"
      :visible.sync="showCustomDate"
      @close="closeEvent"
      width="30%"
    >
      <el-form :model="form" label-position="top">
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item label="Range" prop="dateRange">
              <el-date-picker
                v-model="form.dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="From"
                end-placeholder="To"
                format="dd MMM, yyyy"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="closeEvent">Cancel</el-button>
        <el-button
          type="primary"
         @click="handleGetCustomDate"
          :disabled="form.dateRange.length == 0"
          >Get</el-button
        >
      </span>
    </el-dialog>
    </div> 

    <el-tabs v-model="tab" @tab-click="updateRoute">
      <el-tab-pane v-for="(tab, i) in tabs" :key="i" :label="tab.label" :name="tab.name">
        <!-- add the emit event of update:custom-date to the component -->
        <component :is="`reviews-${tab.name}`" :period="period" :custom-date.sync="customDate" @custom-date-submitted="handleCustomDateSubmitted" />
      </el-tab-pane>
    </el-tabs>


  </div>


</template>

<script>
export default {
  name: "Reviews",
  components: {
    ReviewsBeauty: () =>
      import("@/components/Feedback/Reviews/Beauty/ReviewsBeauty"),
    ReviewsCleaning: () =>
      import("@/components/Feedback/Reviews/Cleaning/ReviewsCleaning"),
    ReviewsLaundry: () =>
      import("@/components/Feedback/Reviews/Laundry/ReviewsLaundry"),
    ReviewsMeal: () => import("@/components/Feedback/Reviews/Meal/ReviewsMeal"),
  },
  data() {
    return {
      tab: "meal",
      loading: false,
      period: "thismonth",
      periods: {
        today: "Today",
        thisweek: "This week",
        thismonth: "This month",
        custom: "Custom",
      },
      showCustomDate: false,
      form: {
        dateRange: [],
      },
      customDate: [],
    };
  },
  computed: {
    services() {
      return this.$store.getters.services;
    },
    tabs() {
      return this.services.map((service) => {
        return {
          label: service.slug === "meal" ? "Food" : service.service_name,
          name: service.slug,
        };
      });
    },
  },
  watch: {
    period() {
      if (this.period == "custom") {
        this.showCustomDate = true;
      }
    },
  },
  created() {
    let { t } = this.$route.query;
    this.tab = t ? t : "meal";
  },
  methods: {
    updateRoute(tab) {
      const currentTab = this.$route.query.t;

      if (currentTab === this.tab) {
        return false;
      }
      this.$router.push({
        name: "reviews.index",
        query: { t: tab.name },
      });
    },
    closeEvent() {
      this.showCustomDate = false;
    },
    setPeriod(period) {
      this.period = period;
    },
    handleGetCustomDate() {
      this.customDate = this.form.dateRange;
      this.showCustomDate = false;
      this.period = 'custom';
    },
  },
};
</script>